import {useDispatch, useSelector} from "react-redux"
import {selectAutomatedSearchSortBy} from "../../../reducers/automatedSearchSortBySlice"
import {
	AUTOMATED_SEARCH_PANEL_VIEW,
	initializePageCount,
	selectAutomatedSearchPanelView,
	selectAutomatedSearchSelectedSearch,
	selectAutoSearchListScrollPosition,
	setAutomatedSearchPanelView,
	setAutoSearchListPosition,
	setSelectedSearch
} from "../../../reducers/automatedSearchViewSlice"
import {Box, Card, CardContent, List, ListItem, Stack, Tooltip, Typography} from "@mui/material"
import {sortAutomatedSearches} from "../../../utils/automatedSearchUtilities"
import {AutomatedSearchOptions} from "./AutomatedSearchOptions"
import { formatDateToISO } from "../../../utils/dates"
import React from "react"
import AutomatedSearchCounts from "./AutomatedSearchTotalCount"
import DiscreteOpenButton from "../../../utils/DiscreteOpenButton"
import {useTabPanelScrollEl} from "../../panels/TabPanel"
import {useScrollPersistence} from "../../../utils/usePersistScrollPosition"
import {DYNAMIC_PANEL_TAB_INDEX_MAP, selectDynamicView} from "../../../reducers/dynamicViewSlice"
import {useWorkspaceContext} from "../../../pages/Dashboard"

const AutomatedSearchList = React.memo( function AutomatedSearchList({
	searches,
	getSearches,
	setSearchToUpdate,
}){
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const sortBy = useSelector((state) => selectAutomatedSearchSortBy(state, workspaceId))
	const listRef = useTabPanelScrollEl() //useRef(null)
	const displayingAutoSearchPanel =useSelector((state) => selectDynamicView(state, workspaceId)) === DYNAMIC_PANEL_TAB_INDEX_MAP.AUTOMATED_SEARCH
	const displayingSearchList = useSelector((state) => selectAutomatedSearchPanelView(state, workspaceId)) === AUTOMATED_SEARCH_PANEL_VIEW.SEARCH_LIST
	const scrollPosition = useSelector((state) => selectAutoSearchListScrollPosition(state, workspaceId))
	const selectedSearch = useSelector((state) => selectAutomatedSearchSelectedSearch(state, workspaceId))

	useScrollPersistence(listRef.current, {
		savedPosition: scrollPosition,
		setPosition: (ratio) => dispatch(setAutoSearchListPosition({ratio, workspaceId})),
		isActive: displayingAutoSearchPanel && displayingSearchList,
		restoreDeps: [displayingAutoSearchPanel, displayingSearchList],
	})

	const selectSearch = (search) => {
		dispatch(initializePageCount({selectedSearch: search, workspaceId}))
		dispatch(setSelectedSearch({search, workspaceId}))
		dispatch(
			setAutomatedSearchPanelView({
				view: AUTOMATED_SEARCH_PANEL_VIEW.ARTICLE_LIST,
				workspaceId
			})
		)
	}
	const handleClick = (evt, search) => {
		evt.stopPropagation()
		selectSearch(search)
	}


	return (
		<List sx={{ padding: "8px 0px 0px 0px" }} >
			{ sortAutomatedSearches(searches, sortBy).map((search) => {
				const backgroundStyle = selectedSearch?.id == search?.id ? {
					backgroundColor: "rgb(0, 179, 197, 0.2)"
				} : {}
				return (
					<ListItem key={search.id} sx={{ padding: "2px 4px" }} id={`search-item-${search.id}`}>
						<Card
							elevation={0}
							sx={{ width: "100%", padding: 0, ...backgroundStyle}}
							variant={"note"}
						>
							<CardContent
								sx={{
									display: "flex",
									flexDirection: "row",
									padding: 0,
									"&:last-child": { padding: 0 },
								}}
							>
								<Box
									sx={{
										flex: "1 1 100%",
										display: "flex",
										flexDirection: "column",
										flexWrap: "wrap",
										justifyContent: "center",
										alignItems: "start",
										padding: "4px 8px",
										minWidth: "300px",
									}}
								>
									<Typography
										variant={"articleTitle"}
										sx={{
											color: "RBOneFont.main",
											width: "100%",
											whiteSpace: "pre-wrap",
										}}
									>
										{search.title}
									</Typography>
									<AutomatedSearchCounts search={search} />
									<Typography
										variant={"subtitle2"}
										sx={{ color: "RBOneFont.otherInfo", width: "100%", marginY: "2px" }}>
										Created At: {formatDateToISO(search.createdAt)}
									</Typography>
								</Box>
								<Stack
									sx={{ display: "inline-flex" }}
									onClick={(e) => {
										e.stopPropagation()
									}}
								>
									<AutomatedSearchOptions
										search={search}
										workspaceId={workspaceId}
										getSearches={getSearches}
										setSearchToUpdate={setSearchToUpdate}
									/>
								</Stack>
							</CardContent>
							<Tooltip
								title={"Open automated search"}
								followCursor
								placement={"right-start"}
							>
								<DiscreteOpenButton
									onClick={(evt) => handleClick(evt, search)}
									variant={"text"}
									color={"otherInfo"}
									sx={{
										marginBottom: "2px",
									}}
								>Open Search</DiscreteOpenButton>
							</Tooltip>
						</Card>
					</ListItem>

				)

			})}
		</List>
	)
})

export default AutomatedSearchList